import page from "./page";
import list from "./list";
import grouping from "./grouping";

export default {
    page,
    list,
    grouping
}